const currency = {
        "AUD": {
            "code": "AUD",
            "name": "Australian dollar",
            "symbol": "$",
            "layout": "symbol number",
            "decimal": ".",
            "thousands": ","
        },
        "CAD": {
            "code": "CAD",
            "name": "Canadian dollar",
            "symbol": "$",
            "layout": "number symbol",
            "decimal": ",",
            "thousands": " "
        },
        "EUR": {
            "code": "EUR",
            "name": "Euro",
            "symbol": "€",
            "layout": "number symbol",
            "decimal": ",",
            "thousands": "."
        },
        "GBP": {
            "code": "GBP",
            "name": "British Pound",
            "symbol": "£",
            "layout": "symbol number",
            "decimal": ".",
            "thousands": ","
        },
        "INR": {
            "code": "INR",
            "name": "Indian rupee",
            "symbol": "₹",
            "layout": "symbol number",
            "decimal": ".",
            "thousands": ",",
            "groupStyle": "indian"
        },
        "JPY": {
            "code": "JPY",
            "name": "Japanese yen",
            "symbol": "¥",
            "layout": "symbol number",
            "decimal": ".",
            "thousands": ","
        },
        "KRW": {
            "code": "KRW",
            "name": "Korean won",
            "symbol": "₩",
            "layout": "symbol number",
            "decimal": ".",
            "thousands": ","
        },
        "MXN": {
            "code": "MXN",
            "name": "Mexican peso",
            "symbol": "$",
            "layout": "symbol number",
            "decimal": ".",
            "thousands": ","
        },
        "RON": {
            "currencyCode": "RON",
            "name": "Romanian leu",
            "symbol": "L",
            "layout": "number symbol",
            "decimal": ",",
            "thousands": "."
        },
        "USD": {
            "code": "USD",
            "name": "United States dollar",
            "symbol": "$",
            "layout": "symbol number",
            "decimal": ".",
            "thousands": ","
        }
    },

    culture = {
        "de-DE": {
            "name": "German",
            "localName": "Deutsch",
            "code": "de-DE",
            "displayName": "German - Deutsch",
            "currency": currency.EUR,
            "unitOfMeasure": "Metric"
        },
        "en-AU": {
            "name": "English (Australian)",
            "localName": "English (AU)",
            "code": "en-AU",
            "displayName": "Australian - English",
            "currency": currency.AUD,
            "unitOfMeasure": "Metric"
        },
        "en-GB": {
            "name": "English (United Kingdom)",
            "localName": "English (UK)",
            "code": "en-GB",
            "displayName": "United Kingdom - English",
            "currency": currency.GBP,
            "unitOfMeasure": "Metric"
        },
        "en-IN": {
            "name": "English (Indian)",
            "localName": "English (India)",
            "code": "en-IN",
            "displayName": "India - English",
            "currency": currency.INR,
            "unitOfMeasure": "Metric"
        },
        "en-US": {
            "name": "English (American)",
            "localName": "English",
            "code": "en-US",
            "displayName": "United States - English",
            "currency": currency.USD,
            "unitOfMeasure": "English"
        },
        "es-MX": {
            "name": "Spanish (Mexican)",
            "localName": "Español",
            "code": "es-MX",
            "displayName": "México - Español",
            "currency": currency.MXN,
            "unitOfMeasure": "Metric"
        },
        "fr-CA": {
            "name": "French (Canadian)",
            "localName": "Français",
            "code": "fr-CA",
            "displayName": "Canada - Français",
            "currency": currency.CAD,
            "unitOfMeasure": "Metric"
        },
        "ja-JP": {
            "name": "Japanese",
            "localName": "日本人",
            "code": "ja-JP",
            "displayName": "日本 - 日本語",
            "currency": currency.JPY,
            "unitOfMeasure": "Metric"
        },
        "ko-KR": {
            "name": "Korean",
            "localName": "한국의",
            "code": "ko-KR",
            "displayName": "대한민국 - 한국어",
            "currency": currency.KRW,
            "unitOfMeasure": "Metric"
        },
        "nl-NL": {
            "name": "Netherlands/Dutch",
            "localName": "Netherlands/Dutch",
            "code": "nl-NL",
            "displayName": "Netherlands/Dutch",
            "currency": currency.EUR,
            "unitOfMeasure": "Metric"
        },
        "ro-RO": {
            "name": "Romanian",
            "localName": "Român",
            "code": "ro-RO",
            "displayName": "Romanian - Român",
            "currency": currency.RON,
            "unitOfMeasure": "Metric"
        }
    };

export const formatCurrency = (code, currency) => {


    const returnValue = culture[code].currency.layout.
        replace(
            "number",
            currency
        ).
        replace(
            "symbol",
            culture[code].currency.symbol
        ).
        replace(
            ".",
            culture[code].currency.decimal
        );
    return returnValue;

};

const groupInternational = (intPartStr, separator) =>
    intPartStr.replace(/\B(?=(\d{3})+(?!\d))/g, separator);

// Indian digit grouping: first group of 3 from the right, then groups of 2 (lakh/crore), e.g. 12345666 -> 1,23,45,666
const groupIndian = (intPartStr, separator) => {
    if (intPartStr.length <= 3) return intPartStr;
    const last3 = intPartStr.slice(-3);
    const rest = intPartStr.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, separator);
    return `${rest}${separator}${last3}`;
};

// `selected` is the Make-level currency config from the backend (e.g. sessionInfo.selected):
// CurrencyCode, Symbol, GroupingStyle ("Standard"/"Indian"), SymbolPosition ("Before"/"After"),
// DecimalPlaces, DecimalSeparator, GroupSeparator. All formatting details come from these fields -
// none of them fall back to this file's per-currency-code `currency` table, so a Make with no
// currency config falls back to the plain defaults below (USD-style).
// respectDisplayOptions is opt-in (default false): when true, the symbol is shown only if
// selected.OptDisplayCurrencySymbol is strictly true - false, unset, or any other value hides it.
export const getSymbolByCurrencyCode = (selected = {}, respectDisplayOptions = false) => {
    if (respectDisplayOptions && selected.OptDisplayCurrencySymbol !== true) return "";
    return selected.Symbol || "$";
};

// respectDisplayOptions is opt-in (default false): when true, decimals are shown only if
// selected.OptDisplayCurrencyDecimal is strictly true - false, unset, or any other value hides them.
export const toMoney = (value, selected = {}, showDecimal = true, respectDisplayOptions = false) => {

    const groupingStyle = selected.GroupingStyle || "Standard",
        decimalPlaces = selected.DecimalPlaces != null ? selected.DecimalPlaces : 2,
        decimalSeparator = selected.DecimalSeparator || ".",
        groupSeparator = selected.GroupSeparator || ",",
        effectiveShowDecimal = respectDisplayOptions ? (showDecimal && selected.OptDisplayCurrencyDecimal === true) : showDecimal,
        num = parseFloat(value);

    if (isNaN(num)) return "NaN";

    const isNegative = num < 0,
        effectiveDecimalPlaces = effectiveShowDecimal ? decimalPlaces : 0,
        fixed = effectiveDecimalPlaces > 0 ? Math.abs(num).toFixed(effectiveDecimalPlaces) : Math.round(Math.abs(num)).toString(),
        [intPart, decPart] = fixed.split("."),
        grouped = groupingStyle === "Indian" ?
            groupIndian(intPart, groupSeparator) :
            groupInternational(intPart, groupSeparator),
        formatted = decPart ? `${grouped}${decimalSeparator}${decPart}` : grouped;

    return isNegative ? `-${formatted}` : formatted;

};

// Full display string: resolves the symbol and amount and places the symbol per SymbolPosition.
// respectDisplayOptions is opt-in (default false) so existing callers are unaffected: when true,
// decimals show only if selected.OptDisplayCurrencyDecimal is strictly true, and the symbol shows
// only if selected.OptDisplayCurrencySymbol is strictly true - anything else hides them.
export const formatCurrencyAmount = (value, selected = {}, showDecimal = true, respectDisplayOptions = false) => {

    const effectiveShowDecimal = respectDisplayOptions ? (showDecimal && selected.OptDisplayCurrencyDecimal === true) : showDecimal,
        amount = toMoney(value, selected, effectiveShowDecimal);

    if (amount === "NaN") return amount;

    if (respectDisplayOptions && selected.OptDisplayCurrencySymbol !== true) return amount;

    const isNegative = amount.startsWith("-"),
        absAmount = isNegative ? amount.slice(1) : amount,
        symbol = getSymbolByCurrencyCode(selected),
        symbolPosition = selected.SymbolPosition || "Before",
        body = symbolPosition === "After" ? `${absAmount}${symbol}` : `${symbol}${absAmount}`;

    return isNegative ? `-${body}` : body;

};

// Builds a culture.js-shaped currency config (PascalCase) from a Make entry returned by
// GetLocationFilters (camelCase, e.g. OEMDashboard's locationFilters.makes). OEM Dashboard-specific:
// other pages source their currency config directly from sessionInfo.selected instead.
export const buildCurrencyConfigFromMake = (make) => {

    if (!make) return {};

    return {
        "CurrencyCode": make.currencyCode,
        "Symbol": make.symbol,
        "GroupingStyle": make.groupingStyle,
        "SymbolPosition": make.symbolPosition,
        "DecimalPlaces": make.decimalPlaces,
        "DecimalSeparator": make.decimalSeparator,
        "GroupSeparator": make.groupSeparator,
        "OptDisplayCurrencyDecimal": make.optDisplayCurrencyDecimal,
        "OptDisplayCurrencySymbol": make.optDisplayCurrencySymbol
    };

};

export const formatDate = (code, date) => new Date(date).toLocaleString(
    culture[code].code,
    {"timeZone": "UTC"}
);

export const formatDateOnly = (code, date) => new Date(date).toLocaleString(
    culture[code].code,
    {
        "timeZone": "UTC",
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }
);

export default culture;
